export const handleActionOneUnit = (
  rowData,
  unit,
  _,
  model,
  setSnackbarOpen = () => {}
) => {
  let units = unit.split("_")[0];
  let sqft = unit.split("_")[1];
  let price = unit.split("_")[2];
  let bedRoom = unit.split("_")[4];
  let bathRoom = unit.split("_")[5];
  let unitAvailabilityText = unit.split("_")[3];
  let move_in_special = unit.split("_")[6];
  let dateNumber = unit.split("_")[7];
  let special_calculation_price = unit.split("_")[7];
  let date = "0";
  let month = "0";
  if (unitAvailabilityText.toLowerCase() == "now") {
    date = new Date().getDate();
    month = parseInt(new Date().getMonth()) + 1;
  } else {
    if (unitAvailabilityText.split(".")?.length == 2) {
      let splitText = unitAvailabilityText.split(".");
      let monthNum = {
        jan: 1,
        feb: 2,
        mar: 3,
        apr: 4,
        may: 5,
        jun: 6,
        jul: 7,
        aug: 8,
        sep: 9,
        sept: 9,
        oct: 10,
        nov: 11,
        dec: 12,
        january: 1,
        february: 2,
        march: 3,
        april: 4,
        june: 6,
        july: 7,
        august: 8,
        september: 9,
        october: 10,
        november: 11,
        december: 12,
      };
      date = splitText[1].trim();
      month = monthNum[splitText[0].toLowerCase().replace(".", "")];
    } else if (unitAvailabilityText.split(",")?.length == 2) {
      let splitText = unitAvailabilityText.split(",");
      let monthNum = {
        jan: "1",
        feb: "2",
        mar: "3",
        apr: "4",
        may: "5",
        jun: "6",
        jul: "7",
        aug: "8",
        sep: "9",
        sept: "9",
        oct: "10",
        nov: "11",
        dec: "12",
        january: "1",
        february: "2",
        march: "3",
        april: "4",
        june: "6",
        july: "7",
        august: "8",
        september: "9",
        october: "10",
        november: "11",
        december: "12",
      };
      date =
        splitText[0]?.split(" ")[1].trim()?.length == 1
          ? splitText[0]?.split(" ")[1].trim()
          : splitText[0]?.split(" ")[1].trim();
      month =
        monthNum[
          splitText[0]?.split(" ")[0].trim().toLowerCase().replace(",", "")
        ];
    } else if (unitAvailabilityText.split(" ")?.length == 2) {
      let splitText = unitAvailabilityText.split(" ");
      let monthNum = {
        jan: 1,
        feb: 2,
        mar: 3,
        apr: 4,
        may: 5,
        jun: 6,
        jul: 7,
        aug: 8,
        sep: 9,
        sept: 9,
        oct: 10,
        nov: 11,
        dec: 12,
        January: 1,
        February: 1,
        March: 2,
        April: 4,
        May: 5,
        June: 6,
        July: 6,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12,
        january: 1,
        february: 2,
        march: 3,
        april: 4,
        june: 6,
        july: 7,
        august: 8,
        september: 9,
        october: 10,
        november: 11,
        december: 12,
      };
      date = splitText[1]
        .trim()
        .replace("nd", "")
        .replace("th", "")
        .replace("st", "")
        .replace("rd", "");
      month = monthNum[splitText[0].toLowerCase()];
    }
  }

  let bedRoomBathText =
    bedRoom == 0 ? "Studio" : bedRoom + "bd•" + bathRoom + "ba";

  //added to fix double pasting issue in iMeesage.
  const modifiedWebsite =
    rowData?.website && typeof rowData?.website === "string"
      ? rowData?.website?.endsWith(".com")
        ? rowData?.website + "/"
        : rowData?.website
      : "";

  const emailContent = `
          <div style="font-size: 16px; font-family: 'Calibri', sans-serif;">
            <p style="font-weight: 700; margin: 0; padding: 0"><a href="${modifiedWebsite}">${
    rowData?.name
      ? rowData?.name + " *" + model + "* (" + modifiedWebsite + ")"
      : " "
  }</a>${
    (
      ((rowData.send == null || rowData.send == "" || rowData.send == 0) &&
        (rowData.bonus == null || rowData.bonus == "" || rowData.bonus == 0) &&
        rowData.escort > 0) ||
      ((rowData.send == 0 || rowData.send == null || rowData.send == "") &&
        rowData.escort != 0 &&
        rowData.escort != null &&
        rowData.escort != "" &&
        rowData.bonus != 0 &&
        rowData.bonus != null &&
        rowData.bonus != "") ||
      (((rowData.send_type == "percentage" &&
        rowData.escort_type == "percentage") ||
        (rowData.send_type == "percentage" && rowData.escort_type == null) ||
        (rowData.send_type == null && rowData.escort_type == "percentage") ||
        (rowData.send_type == null && rowData.escort_type == null)) &&
        rowData.escort > rowData.send) ||
      (rowData.send_type == "dollar" &&
        rowData.escort_type == "dollar" &&
        rowData.escort > rowData.send)
        ? "<b> *if you're interested in touring this property, please let me know, I have to go in person with you to tour in order to receive credit.</b>"
        : ""
    )
      ? "<b> *if you're interested in touring this property, please let me know, I have to go in person with you to tour in order to receive credit.</b>"
      : ""
  }</p>
            <p style="margin: 0; padding: 0">Price: $${price}<span style="font-weight: 700;"> ${rowData?.special?.replace(
    "special= $",
    special_calculation_price != "null"
      ? "special= $<span style='text-decoration: underline;'>" +
          (special_calculation_price == null || special_calculation_price == ""
            ? ""
            : parseInt(special_calculation_price)) +
          "</span>"
      : "special= $"
  )}</span></p>
            <p style="margin: 0; padding: 0">Size: ${sqft} sqft ${bedRoomBathText}</p>
            <p style="margin: 0; padding: 0">Unit: #${units.replace(
              "#",
              ""
            )}</p>
            <p style="margin: 0; padding: 0">Available: ${
              month + "/" + date
            } - ${rowData?.hold_time ? rowData?.hold_time : ""}</p>
            <p style="margin: 0; padding: 0">Location: ${
              rowData?.submarket ? rowData?.submarket : ""
            }</p>
            <p style="margin: 0; padding: 0">${
              rowData?.last_line ? rowData?.last_line : ""
            }</p>
          </div>
        `;

  const plainTextContent = `${
    rowData?.name
      ? `${rowData.name} *${model}* (${modifiedWebsite}) ${
          (
            ((rowData.send == null ||
              rowData.send == "" ||
              rowData.send == 0) &&
              (rowData.bonus == null ||
                rowData.bonus == "" ||
                rowData.bonus == 0) &&
              rowData.escort > 0) ||
            ((rowData.send == 0 ||
              rowData.send == null ||
              rowData.send == "") &&
              rowData.escort != 0 &&
              rowData.escort != null &&
              rowData.escort != "" &&
              rowData.bonus != 0 &&
              rowData.bonus != null &&
              rowData.bonus != "") ||
            (((rowData.send_type == "percentage" &&
              rowData.escort_type == "percentage") ||
              (rowData.send_type == "percentage" &&
                rowData.escort_type == null) ||
              (rowData.send_type == null &&
                rowData.escort_type == "percentage") ||
              (rowData.send_type == null && rowData.escort_type == null)) &&
              rowData.escort > rowData.send) ||
            (rowData.send_type == "dollar" &&
              rowData.escort_type == "dollar" &&
              rowData.escort > rowData.send)
              ? "<b> *if you're interested in touring this property, please let me know, I have to go in person with you to tour in order to receive credit.</b>"
              : ""
          )
            ? "*if you're interested in touring this property, please let me know, I have to go in person with you to tour in order to receive credit."
            : ""
        }`
      : ""
  }
Price: $${price} ${rowData?.special?.replace(
    "special= $",
    special_calculation_price != "null"
      ? "special= $" +
          (special_calculation_price == null || special_calculation_price == ""
            ? ""
            : parseInt(special_calculation_price))
      : "special= $"
  )}
Size: ${sqft} sqft ${bedRoomBathText}
Unit: #${units.replace("#", "")}
Available: ${month + "/" + date} - ${
    rowData?.hold_time ? rowData?.hold_time : ""
  }
Location: ${rowData?.submarket ? rowData?.submarket : ""}
${rowData?.last_line ? rowData?.last_line : ""}`;

  navigator.clipboard
    .write([
      new ClipboardItem({
        "text/html": new Blob([emailContent], { type: "text/html" }),
        "text/plain": new Blob([plainTextContent], { type: "text/plain" }),
      }),
    ])
    .then(() => {
      console.log("Email info copied to clipboard!");
      setSnackbarOpen(true);
    })
    .catch((err) => {
      console.error("Failed to copy email info: ", err);
    });
};

export const handleActionOneUnitNewSpecial = (
  rowData,
  unit,
  _,
  model,
  special_text = "",
  special_price = "",
  setSnackbarOpen = () => {}
) => {
  let units = unit.split("_")[0];
  let sqft = unit.split("_")[1];
  let price = unit.split("_")[2];
  let bedRoom = unit.split("_")[4];
  let bathRoom = unit.split("_")[5];
  let unitAvailabilityText = unit.split("_")[3];

  let special_calculation_price = unit.split("_")[7];
  let date = "0";
  let month = "0";
  if (unitAvailabilityText.toLowerCase() == "now") {
    date = new Date().getDate();
    month = parseInt(new Date().getMonth()) + 1;
  } else {
    if (unitAvailabilityText.split(".")?.length == 2) {
      let splitText = unitAvailabilityText.split(".");
      let monthNum = {
        jan: 1,
        feb: 2,
        mar: 3,
        apr: 4,
        may: 5,
        jun: 6,
        jul: 7,
        aug: 8,
        sep: 9,
        sept: 9,
        oct: 10,
        nov: 11,
        dec: 12,
        january: 1,
        february: 2,
        march: 3,
        april: 4,
        june: 6,
        july: 7,
        august: 8,
        september: 9,
        october: 10,
        november: 11,
        december: 12,
      };
      date = splitText[1].trim();
      month = monthNum[splitText[0].toLowerCase().replace(".", "")];
    } else if (unitAvailabilityText.split(",")?.length == 2) {
      let splitText = unitAvailabilityText.split(",");
      let monthNum = {
        jan: "1",
        feb: "2",
        mar: "3",
        apr: "4",
        may: "5",
        jun: "6",
        jul: "7",
        aug: "8",
        sep: "9",
        sept: "9",
        oct: "10",
        nov: "11",
        dec: "12",
        january: "1",
        february: "2",
        march: "3",
        april: "4",
        june: "6",
        july: "7",
        august: "8",
        september: "9",
        october: "10",
        november: "11",
        december: "12",
      };
      date =
        splitText[0]?.split(" ")[1].trim()?.length == 1
          ? splitText[0]?.split(" ")[1].trim()
          : splitText[0]?.split(" ")[1].trim();
      month =
        monthNum[
          splitText[0]?.split(" ")[0].trim().toLowerCase().replace(",", "")
        ];
    } else if (unitAvailabilityText.split(" ")?.length == 2) {
      let splitText = unitAvailabilityText.split(" ");
      let monthNum = {
        jan: 1,
        feb: 2,
        mar: 3,
        apr: 4,
        may: 5,
        jun: 6,
        jul: 7,
        aug: 8,
        sep: 9,
        sept: 9,
        oct: 10,
        nov: 11,
        dec: 12,
        January: 1,
        February: 1,
        March: 2,
        April: 4,
        May: 5,
        June: 6,
        July: 6,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12,
        january: 1,
        february: 2,
        march: 3,
        april: 4,
        june: 6,
        july: 7,
        august: 8,
        september: 9,
        october: 10,
        november: 11,
        december: 12,
      };
      date = splitText[1]
        .trim()
        .replace("nd", "")
        .replace("th", "")
        .replace("st", "")
        .replace("rd", "");
      month = monthNum[splitText[0].toLowerCase()];
    }
  }

  let bedRoomBathText =
    bedRoom == 0 ? "Studio" : bedRoom + "bd•" + bathRoom + "ba";

  //added to fix double pasting issue in iMeesage.
  const modifiedWebsite =
    rowData?.website && typeof rowData?.website === "string"
      ? rowData?.website?.endsWith(".com")
        ? rowData?.website + "/"
        : rowData?.website
      : "";

  const emailContent = `
          <div style="font-size: 16px; font-family: 'Calibri', sans-serif;">
            <p style="font-weight: 700; margin: 0; padding: 0"><a href="${modifiedWebsite}">${
    rowData?.name
      ? rowData?.name + " *" + model + "* (" + modifiedWebsite + ")"
      : " "
  }</a>${
    (
      ((rowData.send == null || rowData.send == "" || rowData.send == 0) &&
        (rowData.bonus == null || rowData.bonus == "" || rowData.bonus == 0) &&
        rowData.escort > 0) ||
      ((rowData.send == 0 || rowData.send == null || rowData.send == "") &&
        rowData.escort != 0 &&
        rowData.escort != null &&
        rowData.escort != "" &&
        rowData.bonus != 0 &&
        rowData.bonus != null &&
        rowData.bonus != "") ||
      (((rowData.send_type == "percentage" &&
        rowData.escort_type == "percentage") ||
        (rowData.send_type == "percentage" && rowData.escort_type == null) ||
        (rowData.send_type == null && rowData.escort_type == "percentage") ||
        (rowData.send_type == null && rowData.escort_type == null)) &&
        rowData.escort > rowData.send) ||
      (rowData.send_type == "dollar" &&
        rowData.escort_type == "dollar" &&
        rowData.escort > rowData.send)
        ? "<b> *if you're interested in touring this property, please let me know, I have to go in person with you to tour in order to receive credit.</b>"
        : ""
    )
      ? "<b> *if you're interested in touring this property, please let me know, I have to go in person with you to tour in order to receive credit.</b>"
      : ""
  }</p>
            <p style="margin: 0; padding: 0">Price: $${price}<span style="font-weight: 700;"> ${special_text}</span></p>
            <p style="margin: 0; padding: 0">Size: ${sqft} sqft ${bedRoomBathText}</p>
            <p style="margin: 0; padding: 0">Unit: #${units.replace(
              "#",
              ""
            )}</p>
            <p style="margin: 0; padding: 0">Available: ${
              month + "/" + date
            } - ${rowData?.hold_time ? rowData?.hold_time : ""}</p>
            <p style="margin: 0; padding: 0">Location: ${
              rowData?.submarket ? rowData?.submarket : ""
            }</p>
            <p style="margin: 0; padding: 0">${
              rowData?.last_line ? rowData?.last_line : ""
            }</p>
          </div>
        `;

  const plainTextContent = `${
    rowData?.name
      ? `${rowData.name} *${model}* (${modifiedWebsite}) ${
          (
            ((rowData.send == null ||
              rowData.send == "" ||
              rowData.send == 0) &&
              (rowData.bonus == null ||
                rowData.bonus == "" ||
                rowData.bonus == 0) &&
              rowData.escort > 0) ||
            ((rowData.send == 0 ||
              rowData.send == null ||
              rowData.send == "") &&
              rowData.escort != 0 &&
              rowData.escort != null &&
              rowData.escort != "" &&
              rowData.bonus != 0 &&
              rowData.bonus != null &&
              rowData.bonus != "") ||
            (((rowData.send_type == "percentage" &&
              rowData.escort_type == "percentage") ||
              (rowData.send_type == "percentage" &&
                rowData.escort_type == null) ||
              (rowData.send_type == null &&
                rowData.escort_type == "percentage") ||
              (rowData.send_type == null && rowData.escort_type == null)) &&
              rowData.escort > rowData.send) ||
            (rowData.send_type == "dollar" &&
              rowData.escort_type == "dollar" &&
              rowData.escort > rowData.send)
              ? "<b> *if you're interested in touring this property, please let me know, I have to go in person with you to tour in order to receive credit.</b>"
              : ""
          )
            ? "*if you're interested in touring this property, please let me know, I have to go in person with you to tour in order to receive credit."
            : ""
        }`
      : ""
  }
Price: $${price} ${special_text}
Size: ${sqft} sqft ${bedRoomBathText}
Unit: #${units.replace("#", "")}
Available: ${month + "/" + date} - ${
    rowData?.hold_time ? rowData?.hold_time : ""
  }
Location: ${rowData?.submarket ? rowData?.submarket : ""}
${rowData?.last_line ? rowData?.last_line : ""}`;

  navigator.clipboard
    .write([
      new ClipboardItem({
        "text/html": new Blob([emailContent], { type: "text/html" }),
        "text/plain": new Blob([plainTextContent], { type: "text/plain" }),
      }),
    ])
    .then(() => {
      console.log("Email info copied to clipboard!");
      setSnackbarOpen(true);
    })
    .catch((err) => {
      console.error("Failed to copy email info: ", err);
    });
};

export const formatSpecialText = (special = {}, finalPrice) => {
  try {
    const parts = [];

    const monthsFree = parseFloat(special?.months_free ?? 0);
    if (monthsFree > 0) {
      if (Number.isInteger(monthsFree)) {
        parts.push(`+ ${monthsFree} month${monthsFree > 1 ? "s" : ""} free`);
      } else {
        const weeks = Math.round(monthsFree * 4);
        parts.push(`+ ${weeks} week${weeks > 1 ? "s" : ""} free`);
      }
    }

    const concessionText = special?.custom_concession?.trim() || "";
    if (concessionText) {
      parts.push(`+ $${concessionText}`);
    }

    const notesText = special?.notes?.trim() || "";
    if (notesText) {
      parts.push(`+ ${notesText}`);
    }

    let text = parts.join(" ");
    if (finalPrice && special?.lease_term) {
      text += ` // self pro-rated after special = $${finalPrice} (special applies to ${special.lease_term}+ month leases)`;
    } else if (finalPrice) {
      text += ` // self pro-rated after special = $${finalPrice}`;
    }

    return text?.trim();
  } catch (err) {
    console.error("Error formatting special text:", err);
    return "";
  }
};

// const formatSpecialText = (special = {}, finalPrice) => {
//   try {
//     const parts = [];

//     // 1. Months free
//     const monthsFree = parseFloat(special?.months_free ?? 0);
//     if (monthsFree > 0) {
//       parts.push(`+ ${monthsFree} month${monthsFree > 1 ? "s" : ""} free`);
//     }

//     // 2. Concession
//     const concessionRaw = special?.concession ?? "";
//     const lowerConcession = String(concessionRaw).toLowerCase();

//     if (concessionRaw === "$$$$" && special?.custom_concession) {
//       parts.push(`+ $${special?.custom_concession} off`);
//     } else if (
//       lowerConcession === "24 hr lnl" &&
//       special?.custom_concession
//     ) {
//       parts.push(
//         `+ $${special?.custom_concession} off applied within 24 hrs of touring`
//       );
//     } else if (
//       lowerConcession === "48 hr lnl" &&
//       special?.custom_concession
//     ) {
//       parts.push(
//         `+ $${special?.custom_concession} off if applied within 48 hrs of touring`
//       );
//     } else if (
//       lowerConcession.includes("gift") &&
//       special?.custom_concession
//     ) {
//       parts.push(`+ $${special?.custom_concession} ${concessionRaw}`);
//     } else if (
//       lowerConcession.includes("credit") &&
//       special?.custom_concession
//     ) {
//       parts.push(`+ $${special?.custom_concession} ${concessionRaw}`);
//     }

//     // // 3. Custom concession
//     // if (special?.custom_concession) {
//     //   parts.push(`+ ${special.custom_concession}`);
//     // }

//     // Final pricing text
//     let text = parts.join(" ");
//     if (finalPrice && special?.lease_term) {
//       text += ` // self pro-rated after special = $${finalPrice} (for ${special.lease_term}-month lease)`;
//     } else if (finalPrice) {
//       text += ` // self pro-rated after special = $${finalPrice}`;
//     }

//     return text.trim();
//   } catch (err) {
//     console.error("Error formatting special text:", err);
//     return "";
//   }
// };
